<ion-app>
  <ion-menu contentId="main-content" side="start" type="overlay" swipeGesture="false">
    <ion-content>
      <ion-list>        
        <ion-menu-toggle auto-hide="false">
          <ion-item button routerDirection="root" lines="none" detail="false" (click)="closeMenu()" style="cursor: pointer;">
            <ion-icon slot="start" name="arrow-back-outline"></ion-icon>
            <ion-label>Back</ion-label>
          </ion-item>
        </ion-menu-toggle>

        <ion-menu-toggle auto-hide="false">
          <!--
          <ion-item [routerLink]="['tabs/home']" routerDirection="root" lines="none" detail="false" routerLinkActive="active-menu-item">
            <ion-label>Home</ion-label>
          </ion-item>
        -->
          <ion-item [routerLink]="['tabs/expenses']" routerDirection="root" lines="none" detail="false" routerLinkActive="active-menu-item">
            <ion-label>Time and Expenses</ion-label>
          </ion-item>
        </ion-menu-toggle>        
        <ion-menu-toggle auto-hide="false">
          <ion-item [routerLink]="['tabs/about']" routerDirection="root" lines="none" detail="false" routerLinkActive="active-menu-item">
            <ion-label>About</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>